/**
 * 格式化字符串
 * @param str 要格式化的字符串
 * @param obj 值
 * @returns 
 * @example
 *    "Hello, I'm {name}".format({name: 'luolong'})
 */
export function format(str: string, obj: JSON) {
    if (!obj) {
        return str
    }
    return str.replace(/\{([^}]+)\}/g, (match, key) => obj[key])
}